module.exports = __webpack_public_path__ + "static/team_muneeza-1e52284100b6bcbc6588b3bfab2ddbe7.jpg";